export function isDesktopApp(): boolean {
  return navigator.userAgent.toString().indexOf("LiveChatSmartClient") !== -1;
}
